import { required } from "ra-core";
import { useWatch } from "react-hook-form";
import { DateInput } from "@/components/admin/date-input";
import { NumberInput } from "@/components/admin/number-input";
import { ReferenceInput } from "@/components/admin/reference-input";
import { TextInput } from "@/components/admin/text-input";
import { AutocompleteInput } from "@/components/admin/autocomplete-input";

export const TransferInputs = () => {
  const fromAccountId = useWatch({ name: "from_account_id" });
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <ReferenceInput source="from_account_id" reference="accounts">
        <AutocompleteInput
          label="resources.transfers.fields.from_account_id"
          validate={required()}
          helperText={false}
        />
      </ReferenceInput>
      <ReferenceInput
        source="to_account_id"
        reference="accounts"
        filter={fromAccountId ? { "id@neq": fromAccountId } : undefined}
      >
        <AutocompleteInput
          label="resources.transfers.fields.to_account_id"
          validate={required()}
          helperText={false}
        />
      </ReferenceInput>
      <NumberInput
        source="amount"
        validate={required()}
        helperText={false}
        min={1}
      />
      <DateInput source="occurred_at" validate={required()} helperText={false} />
      <TextInput
        source="description"
        multiline
        rows={2}
        className="md:col-span-2"
        helperText={false}
      />
    </div>
  );
};
